import React from 'react';
import { Link } from 'react-router-dom';
import { NavigationSection } from '../navigationConfig';

interface AdminSidebarNavigationProps {
  visibleSections: NavigationSection[];
  isLinkActive: (to: string) => boolean;
  isMobile: boolean;
  onNavigate: () => void;
}

const AdminSidebarNavigation: React.FC<AdminSidebarNavigationProps> = ({
  visibleSections,
  isLinkActive,
  isMobile,
  onNavigate,
}) => {
  return (
    <nav className="admin-nav">
      {visibleSections.map((section) => {
        const sectionLinks = section.links.filter((link) => !!link.to);
        const hasActiveLink = sectionLinks.some((link) => isLinkActive(link.to));

        return (
          <div key={section.title} className="admin-nav-section">
            <div className={`admin-nav-section-title ${hasActiveLink ? 'active' : ''}`}>{section.title}</div>
            {sectionLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`admin-nav-link ${isLinkActive(link.to) ? 'active' : ''}`}
                onClick={() => {
                  if (isMobile) {
                    onNavigate();
                  }
                }}
              >
                {link.label}
              </Link>
            ))}
          </div>
        );
      })}
    </nav>
  );
};

export default AdminSidebarNavigation;